import React, {
  createContext,
  useState,
  useEffect
} from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('userToken');
    if (token) {
      setLoggedIn(true);
    }
  }, []);


  return (
    <AuthContext.Provider
      value={{
        loggedIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
